import React, { useState, useContext, useEffect } from "react";
import ConfigContext from "../context/ConfigContext";
import axios from "axios";
import ViewerInfoContract from "../contracts/ViewerInfoContract";
import loader from "../content/images/icon_loading.gif";
import advisorInsights from "../content/images/AdvisorInsights_2023.svg";
import ModalComponent from "./Modal";

export const TotalAssets = ({ viewer, loading }) => {
	const configData = useContext(ConfigContext);
	const viewerInfo = new ViewerInfoContract(viewer.repFirstName, viewer.repLastName, viewer.last4SsnTin, viewer.primaryRepCode);

	const [modalOpen, setModalOpen] = useState(false);
	const [modalToShow, setModalToShow] = useState("");
	const [loans, setLoans] = useState(null);

	const featureActive = configData.REACT_APP_ADVISOR_INSIGHTS_RELEASE_DATE ? new Date() >= new Date(configData.REACT_APP_ADVISOR_INSIGHTS_RELEASE_DATE) : false;

	const handleShow1099 = () => {
		setModalOpen(true);
		setModalToShow("1099s");
	};

	const handleShowLoans = () => {
		setModalOpen(true);
		setModalToShow("Loans and Notes");
	};

	const fetchReport = async (viewerInfo) => {
		const result = await axios.post(configData.REACT_APP_LOANS_AND_NOTES_URL, viewerInfo);
		return result;
	};

	useEffect(() => {
		fetchReport(viewerInfo).then((result) => {
			setLoans(result.data);
		}).catch(error => {
			console.log("error fetching loans/notes: ", error.message);
		});
	}, [viewer]);

	let buttons;
	if (loans != null && loans.length > 0) {
		buttons =
			<div className="row" style={{ minHeight: "67px", display: "flex", justifyContent: "flex-start", alignItems: "flex-end" }}>
				<div className="col-sm-4 col-md-4 col-lg-4">
					<a href={configData.REACT_APP_PAY_CYCLES_URL} target="_blank" rel="noreferrer"><button className="btn btn-blue float-left">VIEW PAY CYCLE DATES</button></a>
				</div>
				<div className="col-sm-4 col-md-4 col-lg-4">
					<button className="btn btn-blue float-left" onClick={handleShow1099}>VIEW 1099s</button>
				</div>
				<div className="col-sm-4 col-md-4 col-lg-4">
					<button className="btn btn-blue float-left" onClick={handleShowLoans}>VIEW LOANS/NOTES</button>
				</div>
			</div>;
	} else {
		buttons =
			<div className="row" style={{ minHeight: "67px", display: "flex", justifyContent: "flex-start", alignItems: "flex-end" }}>
				<div className="col-sm-6 col-md-6 col-lg-6">
					<a href={configData.REACT_APP_PAY_CYCLES_URL} target="_blank" rel="noreferrer"><button className="btn btn-blue float-left">VIEW PAY CYCLE DATES</button></a>
				</div>
				<div className="col-sm-6 col-md-6 col-lg-6">
					<button className="btn btn-blue float-left btn-blue-lower" onClick={handleShow1099}>VIEW 1099s</button>
				</div>
			</div>;
	};

	let totalAssets;
	if (featureActive) {
		totalAssets =
			<div className="box-layout" style={{ marginBottom: "20px" }}>
				<div className="row" style={{ minHeight: "40px" }}>
					<label>Looking for asset information?</label>
				</div>
				<div className="row" style={{ minHeight: "107px" }}>
					<div className="col-sm-6 col-md-6 col-lg-6">
						<img src={advisorInsights}></img>
					</div>
					<div className="col-sm-6 col-md-6 col-lg-6">
						<a href={configData.REACT_APP_ADVISOR_INSIGHTS_URL} target="_blank" rel="noreferrer"><button className="btn btn-blue float-left">LAUNCH ADVISOR INSIGHTS</button></a>
					</div>
				</div>
				{buttons}
				{modalOpen && <ModalComponent setOpenModal={setModalOpen} modalToShow={modalToShow} viewer={viewerInfo} loans={loans} />}
			</div>;
	} else {
		totalAssets =
			<div className="box-layout" style={{ marginBottom: "20px" }}>
				<div className="row" style={{ minHeight: "40px" }}>
					<label>Total Assets</label>
				</div>
				<div className="row" style={{ minHeight: "107px" }}>
					<div className="col-lg-8">
						<h3>{loading ? <img src={loader} alt="Loading " /> : viewer.totalAssets}</h3>
						<label>Last Paid</label><br></br>
						<p className="AppP">{loading ? <img src={loader} alt="Loading " /> : viewer.lastPaid}</p>
					</div>
				</div>
				{buttons}
				{modalOpen && <ModalComponent setOpenModal={setModalOpen} modalToShow={modalToShow} viewer={viewerInfo} loans={loans} />}
			</div>;
	}

	return (
		totalAssets
	);
};